import { Button, Text, useMantineTheme } from "@mantine/core";

const SocialLoginBtn = (props) => {
  const theme = useMantineTheme();
  return (
    <Button
      fullWidth
      variant={"outline"}
      {...props}
      style={{ height: 44, borderWidth: 2 }}
    >
      <Text size={14} color={theme.colors.grayCustom}>
        <div className="flex items-center">{props.children}</div>
      </Text>
    </Button>
  );
};

export default SocialLoginBtn;
